import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Col,
  message,
  Popconfirm,
  Row,
  Space,
  Table,
  Modal,
  Tooltip,
  Form,
  Select,
  Input,
  Upload,
  Image,
  Switch,
  notification,

} from "antd";

import { SearchOutlined } from '@ant-design/icons';

import { GrUpload } from "react-icons/gr";
import IMAGES from "../../../const/Image";
import Search from "antd/es/input/Search";
import WebBannerRequest from "./WebBannerRequest";
import { components, getRowClassName } from "../../../utils/utils";
import { usePermission } from "../../../hooks/usePermission";

// const confirm = (e) => {
//   console.log(e);
//   message.success("Deleted!");
// };




export const WebBannerList = () => {


      const hasListPermission = usePermission("Banners", "List");
      const hasAddPermission = usePermission("Banners", "Add");
      const hasEditPermission = usePermission("Banners", "Edit");
      const hasDeletePermission = usePermission("Banners", "Delete");

  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [fileList, setFileList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const initialFilter = {
    page: 1
  };
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterForm, setFilterForm] = useState({});
  const [filter, setFilter] = useState(initialFilter);
  const [filteredBanners, setFilteredBnners] = useState([]);
  const [contentType, setContentType] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const { confirm } = Modal;

  const fetchbannerList = () => {
    // const searchFilter = { ...filter, ...filterForm }
    setLoading(true);
    // CategoryRequest.categoryList(searchFilter.page, searchFilter.limit, searchFilter.title)
    WebBannerRequest.getbannerList(filter)
      .then((response) => {
        const rawData = response?.data?.data?.data || [];
        console.log(rawData)
        const totalCount = response?.data?.data?.totalItems || 0;
        setLabList(rawData);
        setFilteredBnners(rawData)
        setTotalRecords(totalCount);
      })
      .catch((error) => {
        message.error("Failed to fetch categories.");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  useEffect(() => {
   
    if(hasListPermission){
      fetchbannerList();
    }
  }, [filter, hasListPermission]);


  const handleStatusChange = (checked, item) => {
    confirm({
      title: `Are you sure you want to ${checked ? "activate" : "deactivate"} this banner?`,
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        setLoading(true);


        // const payload = {
        //   bannerId: item.id, 
        //   title: item.title,
        //   pathType: item.pathType, 
        //   pathId: item.pathId, 
        //   status: checked ? 1 : 0, 
        // };

        // console.log("Payload being sent to API:", payload);

        WebBannerRequest
          .postUpdateBanner({
            id: item.id,
            title: item.title,
            pathType: item.pathType,
            pathId: item.pathId,
            status: checked ? "1" : "0",
          })
          .then((res) => {
            if (res && res.status === 200) {
              notification.success({
                message: "Status updated successfully",
              });

              // Update the local state for banners
              setLabList((prevList) =>
                prevList.map((el) =>
                  el.id === item.id
                    ? { ...el, is_active: checked ? 1 : 0 }
                    : el
                )
              );

              // Refresh the banner list
              fetchbannerList();
            } else {
              notification.error({
                message: "Failed to update status",
              });
            }
          })
          .catch((error) => {
            console.error("Error updating status:", error);
            notification.error({
              message: "Failed to update status",
            });
          })
          .finally(() => {
            setLoading(false);
          });
      },
    });
  };

  const columns = (navigate) => [
    {
      title: "S No.",
      dataIndex: "sno",
      key: "sno",
      render: (value, item, index) => (filter?.page - 1) * 10 + index + 1,
    },
    {
      title: "Banner Name",
      dataIndex: "bannerName",
      key: "bannerName",
    },
    {
      title: "Page Source",
      dataIndex: "pageKey",
      key: "bannerName",
    },
    {
      title: "Desktop Banners",
      dataIndex: "imageUrl",
      key: "imageUrl",
      // width: 120,
      render: (dataIndex) => (
        <img
          src={dataIndex || IMAGES.PlaceholderImage}
          alt="Modal Content"
          style={{ width: "100%", height: "66px" }}
          onClick={() => showModal("image", dataIndex)}
        />
      ),
    },
    // {
    //   title: "Mobile Banners",
    //   dataIndex: "mobileImageUrl",
    //   key: "mobileImageUrl",
    //   // width: 120,
    //   render: (dataIndex) => (
    //     <img
    //       src={dataIndex || IMAGES.PlaceholderImage}
    //       alt="Modal Content"
    //       style={{ width: "100%", height: "66px" }}
    //       onClick={() => showModal("image", dataIndex)}
    //     />
    //   ),
    // },
    // {
    //   title: "Alt Tag",
    //   dataIndex: "altTag",
    //   key: "altTag",
    // },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
    },
    {
      title: "Created By",
      dataIndex: "createdBy",
      key: "createdBy",
    },
    {
      title: "Updated By",
      dataIndex: "updatedBy",
      key: "updatedBy",
    },

    {
      title: "Order By",
      dataIndex: "orderBy",
      key: "orderBy",
    },

    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (is_active, item) => (
        <Switch
          checked={is_active === 1}
          checkedChildren="Active"
          unCheckedChildren="Inactive"
          onChange={(checked) => handleStatusChange(checked, item)}
        />
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <Space size="middle">
          {/* <Tooltip
            title="View Details"
            style={{ color: "red", cursor: "pointer" }}
          >
            <span
              className="action-icon-bg"
              onClick={() => navigate("/categories/details")}
            >
              <img src={IMAGES.ViewIcon} />
            </span>
          </Tooltip> */}
               {hasEditPermission && (
          <Tooltip title="Edit Details">
            <span
              className="action-icon-bg"
              onClick={() => navigate(`/website-management/banner/update/${record.id}`)}
            >
              <img src={IMAGES.EditIcon} />
            </span>
          </Tooltip>
               )}

               {hasDeletePermission && (
          <Popconfirm
            title="Delete the banner"
            description="Are you sure to delete this banner?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <span className="action-icon-bg">
              <img src={IMAGES.DeleteIcon} alt="" />
            </span>
          </Popconfirm>
               )}
        </Space>
      ),
    },
    // Add other columns as needed
  ];

  const handleFilter = (value) => {
    setFilter({ ...filter, ...filterForm, ...initialFilter })
    console.log('filter', filter)
    setIsModalOpen(false)
  }
  const handleChange = (pagination) => {
    setFilter({
      ...filter,
      page: pagination?.current
    })
  }

  const resetFilters = () => {
    form.resetFields();
    setFilterForm({});
    setFilter(initialFilter);
  };

  const showModal = (type, url) => {
    setContentType(type);
    setModalContent(url);
    setIsModalVisible(true);
  };
  const handleCancels = () => {
    setIsModalVisible(false);
    setContentType(null);
    setModalContent(null);
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) =>
    setFileList(newFileList);
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
    >
      <GrUpload />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    WebBannerRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          imageUrl: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  const handleDelete = (bannerId) => {

       if (!hasDeletePermission) {
          notification.error({
            message: "You don't have permission to delete banners",
          });
          return;
        }

    setLoading(true);
    WebBannerRequest.postDeleteBanner(bannerId)
      .then(() => {
        message.success("Banners deleted successfully");
        setLabList((prevList) => prevList.filter((item) => item.bannerId !== bannerId));
        navigate(0, { state: { refresh: true } });
      })
      .catch((error) => {
        message.error("Failed to delete banner");
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };


  // const props = {
  //   name: "file",
  //   multiple: false,
  //   beforeUpload: (file) => {

  //     imageUpload(file, file.name);
  //     return false;
  //   },
  //   onRemove() {
  //     setFileList([]);
  //   },
  // };

    const props = {
      name: "file",
      multiple: false,
      accept : "image/*",
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if(!isImage){
          notification.error({
            message : "Invalid file type",
            description : "Only image files are allowed (jpg, png, jpeg, webp)",
          });
          return Upload.LIST_IGNORE; 
        }
        imageUpload(file, file.name);
        return false;
      },
      onRemove() {
        setFileList([]);
      },
    };

  return (
    <>
      <div className="">
        <Row gutter={[8, 8]} justify="space-between" align="middle">
          <Col>
            <h1 className="app-heading-med">Website Banners</h1>
          </Col>
          <Col>

            <div style={{ display: "flex", gap: "1rem" }}>
              <Input
                placeholder="Search by banner name"
                size="large"
                className="FilterSearchBox"
                onChange={(e) => setFilterForm({ ...filterForm, search: e.target.value })}
                value={filterForm?.search}
                style={{ width: "100%" }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    handleFilter();
                  }
                }}
              />
              <Button
                onClick={handleFilter}
                type="primary"
                htmlType="submit"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <SearchOutlined />
              </Button>
              <Button

                type="primary"
                className="addcity-btn"
                onClick={resetFilters}
                style={{ height: "39px" }}
              >
                Reset
              </Button>
                   {hasAddPermission && (
              <Button
                onClick={() => navigate("/website-management/banner/create")}
                type="primary"
                className="addcity-btn"
                style={{ height: "39px" }}
              >
                <img src={IMAGES.AddIconFilters} alt="Add" />
              </Button>
                   )}
            </div>
          </Col>
          {/* <Col style={{ gap: "5px" }}>
            <Button
            onClick={showAddModal}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
            >
              <img src={IMAGES.AddIconFilters} alt="" />
            </Button>
          </Col> */}
        </Row>
      </div>
      <div style={{ marginTop: '20px' }}>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          onChange={handleChange}
          dataSource={filteredBanners}
          pagination={{
            total: totalRecords,
            current: filter?.page || 0,
            defaultCurrent: 1
          }}
        />
      </div>




      <Modal
        title={contentType === "Image" ? "Image" : "Image"}
        visible={isModalVisible}
        footer={null}
        onCancel={handleCancels}
        width={contentType === "image" ? 800 : 600}
      >
        {contentType === "image" && (
          <img
            src={modalContent}
            alt="Modal Content"
            style={{ width: "100%" }}
          />
        )}

      </Modal>
    </>
  );
};
